import { useTranslation } from 'react-i18next';

import { INTEGRATION_STATUS } from '@/entities/integrations';
import { Chip } from '@/shared/ui/Chip';

import { INTEGRATION_STATUS_TO_I18_KEY } from '../model/constants';

type TIntegrationStatusProps = {
  status: boolean;
};

const STATUS_COLORS = {
  [INTEGRATION_STATUS.ACTIVE]: 'success',
  [INTEGRATION_STATUS.INACTIVE]: 'error',
} as const;

export const IntegrationsStatus = ({ status }: TIntegrationStatusProps) => {
  const { t } = useTranslation();

  const isActive = status
    ? INTEGRATION_STATUS.ACTIVE
    : INTEGRATION_STATUS.INACTIVE;

  return (
    <Chip
      label={t(INTEGRATION_STATUS_TO_I18_KEY[isActive])}
      color={STATUS_COLORS[isActive]}
      size="small"
    />
  );
};
